<div class="manufacturer-popover-content">
   <p class="popover-title">
    {{ user?.ac_first_name }} {{ user?.ac_last_name }}
   </p>
   <p class="popover-title">
    {{ user?.ac_livith_code }}
   </p>
  <p class="popover-title">
    {{ user?.ac_email }}
  </p>

  <hr class="popover-divider" />
  <button class="popover-action-btn" (click)="changePassword()">
    CAMBIA PASSWORD
    <i class="bx bx-user-circle"></i>
  </button>
  <button class="popover-action-btn logout" (click)="logout()">
    LOGOUT
    <i class="bx bx-log-out"></i>
  </button>
</div>
